// extracted by mini-css-extract-plugin
export default {"partner":"Partner_partner__XI50Q","link":"Partner_link__b1DwY"};